/// <amd-module name="DirtyDocumentServices/Redux/DirtyDocumentsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { monitorDirtyDocuments } from "DirtyDocumentServices/Redux/DirtyDocumentsSaga";

export const DirtyDocumentsModule: ISagaModule<never> = {
    id: "dirty-documents",
    sagas: [monitorDirtyDocuments]
};
